import Skeleton from 'components/Skeleton';

const CommentListItemSkeleton = () => (
  <div className="flex flex-col rounded-4 bg-neutral-high-200 px-4 py-2 dark:bg-neutral-low-400">
    <div className="mb-4 flex items-center gap-x-3">
      <Skeleton className="size-6 rounded-full" />
      <Skeleton className="h-4 w-32 rounded-4" />
      <Skeleton className="ml-auto h-4 w-20 rounded-4" />
      <Skeleton className="mr-1 size-10 rounded-3" />
    </div>
    <Skeleton className="h-4 w-3/4 rounded-4" />
    <Skeleton className="mt-2 h-4 w-1/4 rounded-4" />
    <div className="mt-2 flex gap-x-3">
      <Skeleton className="h-5 w-10 rounded-3" />
      <Skeleton className="size-5 rounded-3" />
      <Skeleton className="h-5 w-10 rounded-3" />
    </div>
  </div>
);

export default CommentListItemSkeleton;
